import { securityDetailsActions } from "../../actions";
import { bwicLogActions } from "../../actions/bwic-log.actions";
import { useAppDispatch } from "../../effects/useAppDispatch";
import { useAppSelector } from "../../effects/useAppSelector";
import { TabItem, TabList } from "../bidding/common/tab-list";
import { Popup, PopupBody, PopupFooter } from "../controls";
import { BWICLog } from "./bwic-log/BWICLog";
import { SecurityDetails } from "./SecurityDetails";
import SecurityDetailsOptions from "./SecurityDetailsOptions";

interface Props {
    onClose: () => void;
}

export function SecurityDetailsPopup({onClose}: Props) {
    const dispatch = useAppDispatch();

    const bwicLog = useAppSelector(s => s.bwicLog.security);
    const securityDetails = useAppSelector(s => s.securityDetails.security);

    const security = bwicLog || securityDetails;

    if (!security) return null;

    const handleClose = () => {
        onClose();

        dispatch(securityDetailsActions.securityDetailsReset());
        dispatch(bwicLogActions.bwicLogReset());
    }

    return (
        <Popup
            renderInBody
            title={
                <>
                    <>{security.ticker}</>
                    <SecurityDetailsOptions position={security} onAddToPortfolioClick={handleClose} />
                </>
            }
            onClose={handleClose}
            modalClass="security-information-modal"
        >
            <PopupBody>
                <TabList>
                    <TabItem
                        title="Security"
                        active={!!securityDetails}
                        onClick={() => {
                            dispatch(bwicLogActions.bwicLogReset());
                            dispatch(securityDetailsActions.securityDetailsInitRequest(security, true));
                        }}
                    />
                    <TabItem
                        title="BWIC Log"
                        active={!!bwicLog}
                        onClick={() => {
                            dispatch(securityDetailsActions.securityDetailsReset());
                            dispatch(bwicLogActions.bwicLogShow(security));
                        }}
                    />
                </TabList>
                {!!securityDetails && <SecurityDetails onViewDocumentsClick={handleClose} />}
                {!!bwicLog && <BWICLog />}
            </PopupBody>
            <PopupFooter>
                <button className="btn btn-ghost" onClick={handleClose}>Close</button>
            </PopupFooter>
        </Popup>
    );
}